import { Directive } from '@angular/core';
import {NavService} from 'shared/nav/nav.service';

@Directive()
export abstract class DefaultPage {

  constructor(
    private _navService: NavService,
  ) {}
  
  public showMenu(): void {
    this._navService.push('menu');
  }

  public goHome(): void {
    this._navService.root('dashboard');
  }

  public goBack(): void {
    this._navService.pop();
  }

}
